import {BasePage} from '../utils/base';
import '../css/chats.scss';
import {Messages} from './messages';

export class ChatsPage extends BasePage {
  view;
  leftPanel;
  chatItems;

  inited = false;

  timeouts = {};
  statusesTimeouts = {};

  files = {};
  filesToChatId = {};
  order = [];
  userStatus = {};

  constructor() {
    super();

    // return;

    if (!this.storeHelper.store.keepMeSign) {
      window.onunload = () => {
        localStorage.setItem('logout', '1');
        this.apiHelper.logOut();
      };
    }

    let viewTemplate = this.templates.querySelector('.chats');
    this.setPage(viewTemplate.cloneNode(true));

    this.view = this.app.querySelector('.chats');
    this.leftPanel = this.sel('.left-panel', this.view);
    this.chatItems = this.sel('.small-chats', this.view);

    this.addEvent(this.chatItems, 'scroll', this.onScroll);

    let waitNetwork = this.sel('.wait-network', this.view);

    let logOutBtn = this.sel('.header-menu', this.view);
    this.addEvent(logOutBtn, 'click', () => {
      this.apiHelper.logOut();
    });

    let lastConnectionState = 'connectionStateReady';

    setInterval(() => {
      if (lastConnectionState !== 'connectionStateReady' || !window.navigator.onLine) {
        this.ac(waitNetwork, 'visible');
      } else {
        this.rc(waitNetwork, 'visible');
      }
    }, 500);

    this.apiHelper.subscribers.push(res => {
      if (res['@type'] === 'updateConnectionState') {
        lastConnectionState = res.state['@type'];
      }

      if (!this.inited) {
        return;
      }

      let chatId;
      if (res.chat_id) {
        chatId = res.chat_id;
      } else if (res.chat) {
        chatId = res.chat.id;
      } else if (res['@type'] === 'updateUserStatus') {
        let userId = res.user_id;
        if (this.storeHelper.store[userId]) {
          this.userStatus[userId] = res;
          this.renderSmallChat(userId);
        }
        return;
      } else if (res['@type'] === 'updateFile') {
        let fileId = res.file.id;
        chatId = this.filesToChatId[fileId];

        if (this.files[fileId] === 'pending' && res.file.expected_size === res.file.local.downloaded_size) {
          this.files[fileId] = 'success';
          this.renderSmallChat(chatId);
          return;
        }
      }

      if (!chatId) {
        // console.log('unexpected event: ', res);
        return;
      }

      clearTimeout(this.timeouts[chatId]);
      this.timeouts[chatId] = setTimeout(() => {
        this.apiHelper
          .getChat(chatId)
          .then(res => {
            this.storeHelper.setStore({[res.id]: res});
          })
          .catch(err => console.log('error get chart ', err));
      }, 500);
    });

    this.addLoading('.left-panel .loading');
    this.addLoading('.wait-network .wait-loading');

    this.apiHelper.getChats(null).then(res => {
      this.inited = true;
      this.rc(this.leftPanel, 'loading');

      this.getChatsInfo(res);
    });
  }

  getChatsInfo(res) {
    res.chat_ids.forEach(chatId => {
      this.apiHelper.getChat(chatId).then(res => {
        this.storeHelper.setStore({[res.id]: res});

        this.storeHelper.subscribe([res.id], () => {
          this.renderSmallChat(res.id);
        });

        this.renderSmallChat(res.id);
      });
    });
    // console.log(res.chat_ids);
  }

  messages;

  renderSmallChat(chatId) {
    let divWrapper = this.view.querySelector(`[chatid="${chatId}"]`);
    let chatInfo = this.storeHelper.store[chatId];

    if (!divWrapper) {
      divWrapper = document.createElement('div');
      divWrapper.setAttribute('chatid', chatId);

      this.view.querySelector('.small-chats').appendChild(divWrapper);

      let userChatTempate = this.templates.querySelector('.user-chat');
      divWrapper.appendChild(userChatTempate.cloneNode(true));

      divWrapper.addEventListener('click', async () => {
        if (this.messages) {
          await this.messages.closeChat();
        }
        this.messages = new Messages(chatInfo, this);
      });
    }

    // console.log('chatInfo ', chatInfo);

    let fileUrl;
    if (chatInfo.photo) {
      fileUrl = this.getFilePic(chatInfo);
    }

    if (fileUrl) {
      if (fileUrl !== divWrapper.querySelector('.pic').getAttribute('url')) {
        let newPic = `<img src="${fileUrl}" />`;

        divWrapper.querySelector('.pic').setAttribute('url', fileUrl);
        divWrapper.querySelector('.pic').innerHTML = newPic;
        divWrapper.querySelector('.pic').classList.add('img');
      }
    } else {
      let titleArr = chatInfo.title.split(' ');
      let picText = 'DEL';

      if (chatInfo.title) {
        picText = titleArr[0][0] + (titleArr.length > 1 ? titleArr[titleArr.length - 1][0] : '');
      }
      divWrapper.querySelector('.pic').innerHTML = `<span>${picText}</span>`;
    }

    let userChat = divWrapper.querySelector('.user-chat');
    if (this.apiHelper.userId === chatId) {
      userChat.classList.add('savedMessages');
      divWrapper.querySelector('.user-name').innerHTML = 'Saved Messages';
    } else {
      divWrapper.querySelector('.user-name').innerHTML = chatInfo.title;
    }

    divWrapper.querySelector('.user-message').innerHTML = this.getChatLastMessage(chatInfo);
    divWrapper.querySelector('.user-time').innerHTML = this.getLastMessageTime(chatInfo);

    if (chatInfo.unread_count) {
      divWrapper.querySelector('.user-count').innerHTML = `<div>${chatInfo.unread_count}</div>`;
    } else {
      divWrapper.querySelector('.user-count').innerHTML = '';
    }

    let isOnline = this.getIsOnline(chatInfo);
    if (isOnline) {
      userChat.classList.add('isOnline');
    } else {
      userChat.classList.remove('isOnline');
    }

    if (chatInfo.notification_settings.mute_for) {
      userChat.classList.add('muted');
    } else {
      userChat.classList.remove('muted');
    }

    if (chatInfo.is_pinned) {
      userChat.classList.add('pinned');
      if (!chatInfo.unread_count) {
        divWrapper.querySelector('.user-count').innerHTML = `<div class="pinned"></div>`;
      }
    } else {
      userChat.classList.remove('pinned');
    }

    let prevOrder = this.getOrderFull(chatId);
    if (!prevOrder || (prevOrder && prevOrder.order !== chatInfo.order)) {
      this.order = this.order.filter(or => or.chatId !== chatId);
      this.order.push({chatId, order: chatInfo.order});

      this.setSort(() => {
        let chats = this.view.querySelectorAll('.user-chat');
        chats.forEach(chatEl => {
          let chatIdEl = chatEl.parentElement.getAttribute('chatid');
          let newOrder = this.getOrder(chatIdEl) + 1;

          if (newOrder != chatEl.parentElement.style.order) {
            chatEl.parentElement.style.order = newOrder;
          }
        });

        chats = this.view.querySelectorAll('.user-chat.last-pinned');
        chats.forEach(chatEl => chatEl.classList.remove('last-pinned'));

        chats = this.view.querySelectorAll('.user-chat.pinned');
        chats.forEach(chatEl => {
          let chatIdEl = chatEl.parentElement.getAttribute('chatid');
          let newOrder = this.getOrder(chatIdEl) + 1;

          if (newOrder === chats.length) {
            chatEl.classList.add('last-pinned');
          }
        });
      });
    }
  }

  timeoutSort;
  setSort(cb) {
    clearTimeout(this.timeoutSort);
    this.timeoutSort = setTimeout(() => {
      this.order.sort((a, b) => {
        let lenA = a.order.length;
        let lenB = b.order.length;

        if (lenA === lenB) {
          for (let i = 0; i < lenA; i++) {
            let numA = parseInt(a.order[i]);
            let numB = parseInt(b.order[i]);

            if (numA !== numB) {
              return numB - numA;
            }
          }
          return 0;
        }
        return lenB - lenA;
      });

      cb();
    }, 100);
  }

  getOrder(chatId) {
    for (let i = 0; i < this.order.length; i++) {
      if (this.order[i].chatId == chatId) {
        return i;
      }
    }
  }

  getOrderFull(chatId) {
    for (let i = 0; i < this.order.length; i++) {
      if (this.order[i].chatId == chatId) {
        return this.order[i];
      }
    }
  }

  getChatLastMessage(chatInfo) {
    if (!chatInfo.last_message) {
      return;
    }

    let messageType = chatInfo.last_message.content['@type'];

    if (messageType === 'messageText') {
      return chatInfo.last_message.content.text.text;
    }

    return messageType.replace('message', '');
  }

  getLastMessageTime(chatInfo) {
    if (!chatInfo.last_message) {
      return;
    }

    let date = new Date(chatInfo.last_message.date * 1000);
    let today = new Date();

    let options = {year: 'numeric', month: 'numeric', day: 'numeric'};
    let stringDate = date.toLocaleDateString('en-US', options);
    let stringTodayDate = today.toLocaleDateString('en-US', options);

    if (stringDate === stringTodayDate) {
      let hours = date.getHours();
      let minutes = date.getMinutes();

      return `${hours}:${minutes < 10 ? '0' + minutes : minutes}`;
    } else if ((today.getTime() - date.getTime()) / 1000 / 60 / 60 / 24 < 7) {
      return date.toLocaleDateString('en-US', {weekday: 'short'});
    }

    return stringDate;
  }

  getIsOnline(chatInfo) {
    let chatId = chatInfo.id;
    let isOnline = false;

    if (this.userStatus[chatId]) {
      clearTimeout(this.statusesTimeouts[chatId]);

      let status = this.userStatus[chatId].status['@type'];
      let expires = this.userStatus[chatId].status.expires * 1000;

      if (status === 'userStatusOnline' && expires - Date.now() > 0) {
        isOnline = true;

        this.statusesTimeouts[chatId] = setTimeout(() => {
          this.userStatus[chatId] = undefined;
          this.renderSmallChat(chatId);
        }, expires - Date.now());
      }
    }

    return isOnline;
  }

  getFilePic(chatInfo) {
    let chatId = chatInfo.id;

    let fileId = chatInfo.photo.small.id;
    this.filesToChatId[fileId] = chatId;

    if (!this.files[fileId]) {
      this.files[fileId] = 'download';
      this.apiHelper
        .downloadFile(fileId)
        .then(() => {
          this.files[fileId] = 'pending';
        })
        .catch(() => (this.files[fileId] = 'error'));
    } else if (this.files[fileId] === 'success') {
      this.apiHelper.getFile(fileId).then(file => {
        this.files[fileId] = window.URL.createObjectURL(file.data);
        this.renderSmallChat(chatId);
      });
    }

    let isBlob = this.files[fileId].indexOf('blob') !== -1;
    return isBlob ? this.files[fileId] : null;
  }

  scrollTimeout;
  loadingChats = false;
  onScroll = event => {
    if (this.loadingChats) {
      return;
    }

    clearTimeout(this.scrollTimeout);
    this.scrollTimeout = setTimeout(() => {
      if (event.target.scrollHeight - event.target.offsetHeight - event.target.scrollTop < 300) {
        let chats = this.view.querySelectorAll('.user-chat');
        let chatId = chats[chats.length - 1].parentElement.getAttribute('chatid');
        let chatInfo = this.storeHelper.store[chatId];

        this.loadingChats = true;
        this.apiHelper
          .getChats(chatInfo)
          .then(async res => {
            let newChats = {};
            for (let i = 0; i < res.chat_ids.length; i++) {
              let chatId = res.chat_ids[i];

              let chatRes = await this.apiHelper.getChat(chatId);
              newChats[chatRes.id] = chatRes;

              this.storeHelper.subscribe([chatRes.id], () => {
                this.renderSmallChat(chatRes.id);
              });
            }

            this.storeHelper.setStore({...newChats});
          })
          .finally(() => (this.loadingChats = false));
      }
    }, 100);
  };
}
